import mixpanel from "mixpanel-browser";

function track(eventName, userId = null) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  mixpanel.track(eventName);

  if (userId) {
    mixpanel.identify(userId);
  }
}

export default track;
